import React, { createContext, useEffect, useState } from 'react';

import * as Sentry from '@sentry/react';
import { logInfo, logWarn, logError } from 'apps/auth/helpers/clientLogger';
import { initializeApp } from 'firebase/app';
import { fetchAndActivate, getAll, getRemoteConfig } from 'firebase/remote-config';

export const FlagsContext = createContext({});
const firebaseConfig = {
    apiKey: 'AIzaSyBtT4CJXRHkJdrOM2NdPGUKoOXifeYkANI',
    authDomain: 'paysend-67ec2.firebaseapp.com',
    databaseURL: 'https://paysend-67ec2.firebaseio.com',
    projectId: 'paysend-67ec2',
    storageBucket: 'paysend-67ec2.appspot.com',
    messagingSenderId: '65660059720',
    appId: '1:65660059720:web:183793ea0b33b7e999587d',
    measurementId: 'G-JDYSKWCQPX',
};
const firebaseApp = initializeApp(firebaseConfig);
const remoteConfig = () => {
    if (__isBrowser__) {
        try {
            return getRemoteConfig(firebaseApp);
        } catch (e) {
            Sentry.captureException(e, {
                level: 'log',
            });
            logWarn(e);
        }
    }
    return {};
};

const FlagsProvider = ({ defaults, children }) => {
    const [flags, setFlags] = useState(defaults);

    useEffect(() => {
        const rConfig = remoteConfig();
        rConfig.defaultConfig = defaults;
        rConfig.settings = {
            minimumFetchIntervalMillis: __isDev__ ? 3600000 : 60000,
        };

        if (__isBrowser__) {
            fetchAndActivate(rConfig)
                .then((activated) => {
                    if (!activated) logInfo('not activated');
                    return getAll(rConfig);
                })
                .then((remoteFlags) => {
                    const newFlags = {
                        ...flags,
                    };

                    for (const [key, config] of Object.entries(remoteFlags)) {
                        newFlags[key] = config.asString();
                    }

                    setFlags(newFlags);
                })
                .catch((error) => logError(error));
        }
    }, []);

    return <FlagsContext.Provider value={flags}>{children}</FlagsContext.Provider>;
};

export default FlagsProvider;
